export default __webpack_public_path__ + "assets/svg/Barbell.076f4083f1632196a8a869feb4eb3117.svg";